import { ReactComponent as UR7 } from '../assets/teeth/U-01.svg';
import { ReactComponent as UR6 } from '../assets/teeth/U-02.svg';
import { ReactComponent as UR5 } from '../assets/teeth/U-03.svg';
import { ReactComponent as UR4 } from '../assets/teeth/U-04.svg';
import { ReactComponent as UR3 } from '../assets/teeth/U-05.svg';
import { ReactComponent as UR2 } from '../assets/teeth/U-06.svg';
import { ReactComponent as UR1 } from '../assets/teeth/U-07.svg';
import { ReactComponent as UL1 } from '../assets/teeth/U-08.svg';
import { ReactComponent as UL2 } from '../assets/teeth/U-09.svg';
import { ReactComponent as UL3 } from '../assets/teeth/U-10.svg';
import { ReactComponent as UL4 } from '../assets/teeth/U-11.svg';
import { ReactComponent as UL5 } from '../assets/teeth/U-12.svg';
import { ReactComponent as UL6 } from '../assets/teeth/U-13.svg';
import { ReactComponent as UL7 } from '../assets/teeth/U-14.svg';
import { ReactComponent as LR7 } from '../assets/teeth/L-01.svg';
import { ReactComponent as LR6 } from '../assets/teeth/L-02.svg';
import { ReactComponent as LR5 } from '../assets/teeth/L-03.svg';
import { ReactComponent as LR4 } from '../assets/teeth/L-04.svg';
import { ReactComponent as LR3 } from '../assets/teeth/L-05.svg';
import { ReactComponent as LR2 } from '../assets/teeth/L-06.svg';
import { ReactComponent as LR1 } from '../assets/teeth/L-07.svg';
import { ReactComponent as LL1 } from '../assets/teeth/L-08.svg';
import { ReactComponent as LL2 } from '../assets/teeth/L-09.svg';
import { ReactComponent as LL3 } from '../assets/teeth/L-10.svg';
import { ReactComponent as LL4 } from '../assets/teeth/L-11.svg';
import { ReactComponent as LL5 } from '../assets/teeth/L-12.svg';
import { ReactComponent as LL6 } from '../assets/teeth/L-13.svg';
import { ReactComponent as LL7 } from '../assets/teeth/L-14.svg';

export default [
  {
    name: 'UR8',
    icon: UR7
  },
  {
    name: 'UR7',
    icon: UR7
  },
  {
    name: 'UR6',
    icon: UR6
  },
  {
    name: 'UR5',
    icon: UR5
  },
  {
    name: 'UR4',
    icon: UR4
  },
  {
    name: 'UR3',
    icon: UR3
  },
  {
    name: 'UR2',
    icon: UR2
  },
  {
    name: 'UR1',
    icon: UR1
  },
  {
    name: 'UL1',
    icon: UL1
  },
  {
    name: 'UL2',
    icon: UL2
  },
  {
    name: 'UL3',
    icon: UL3
  },
  {
    name: 'UL4',
    icon: UL4
  },
  {
    name: 'UL5',
    icon: UL5
  },
  {
    name: 'UL6',
    icon: UL6
  },
  {
    name: 'UL7',
    icon: UL7
  },
  {
    name: 'UL8',
    icon: UL7
  },
  {
    name: 'LR8',
    icon: LR7
  },
  {
    name: 'LR7',
    icon: LR7
  },
  {
    name: 'LR6',
    icon: LR6
  },
  {
    name: 'LR5',
    icon: LR5
  },
  {
    name: 'LR4',
    icon: LR4
  },
  {
    name: 'LR3',
    icon: LR3
  },
  {
    name: 'LR2',
    icon: LR2
  },
  {
    name: 'LR1',
    icon: LR1
  },
  {
    name: 'LL1',
    icon: LL1
  },
  {
    name: 'LL2',
    icon: LL2
  },
  {
    name: 'LL3',
    icon: LL3
  },
  {
    name: 'LL4',
    icon: LL4
  },
  {
    name: 'LL5',
    icon: LL5
  },
  {
    name: 'LL6',
    icon: LL6
  },
  {
    name: 'LL7',
    icon: LL7
  },
  {
    name: 'LL8',
    icon: LL7
  }
];
